import utils from 'helpers/utils';
import logger from 'helpers/logger';
import ServiceStore from 'stores/service.store';

const path = utils.servicePath(import.meta.url);

export class CollectionUserService extends ServiceStore {
  constructor (app, callbacks) {
    logger.trace(`Starting module at: services/${path}`);

    super(path, app, {
      key: 'userId',
      refreshEnabled: false,
      invalidateParent: true,
      invalidateByEntity: false,
      invalidateParentWithPriority: true
    }, callbacks);
  }
}
